export default function formatMillis(millis) {
  const timeSeconds = Math.ceil(millis / 1000);
  return `${Math.floor(timeSeconds / 60)
    .toString()
    .padStart(2, '0')}:${(timeSeconds % 60).toString().padStart(2, '0')}`;
}
